import React from 'react'

export default function PageNotFound() {

  return (
    <div>
      This page does not exist.
    </div>
  )
}